var map = {
	"./fa01/fa01_capa.jpg": 52312,
	"./fa010/fa010_capa.jpg": 22032,
	"./fa02/fa02_capa.jpg": 78567,
	"./fa03/fa03_capa.jpg": 62852,
	"./fa04/fa04_capa.jpg": 10863,
	"./fa05/fa05_capa.jpg": 68547,
	"./fa06/fa06_capa.jpg": 9384,
	"./fa07/fa07_capa.jpg": 86700,
	"./fa08/fa08_capa.jpg": 43001,
	"./fa09/fa09_capa.jpg": 84960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18193;